module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('toolbar'), _vm._v(" "), _c('notes-list'), _vm._v(" "), _c('editor')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38fd50dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 117
// module chunks = 2